import { c as _c } from "react/compiler-runtime";
import React from 'react';
const PaymentNotificationSettingsSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="bg-background-secondary [&>*]:flex-1 flex h-fit w-full animate-pulse flex-col gap-7 overflow-x-hidden rounded-md p-5"><div className="bg-skeleton-primary rounded-sm py-0.5 text-transparent">.</div><div className="bg-skeleton-primary rounded-sm py-0.5 text-transparent">.</div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default PaymentNotificationSettingsSkeleton;